const qcNoteIT = {
    "view": {
        "message": {
            "releaseHasQCIssues": "La release {{releaseName}} ha problemi di QC, modifica la release per un feedback dettagliato sul QC, apporta le modifiche necessarie e reinvia!",
            "trackHasQCIssues": "Il brano {{trackName}} ha problemi di QC, modifica il brano per un feedback dettagliato sul QC, apporta le modifiche necessarie e reinvia!"
        }
    }
};

export default qcNoteIT;